import { encode as base64_encode } from "base-64";

import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class KeynottagRepStore {
    loading = false;
    total = 0;
    keyNotTagged = [];
    tripData = [];

    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            loading: observable,
            total: observable,
            keyNotTagged: observable,
            tripData: observable,

            loadData: action,

            exportExcel: action,
            exportpdf: action,
        });
        this.rootStore = rootStore;
    }

    async loadData({
        companyId,
        vehicleId,
        fromDate,
        toDate,
        offset,
        limit,
        pageNo,
        reportName
    }) {
        this.loading = true;
        var postData = {
            companyId: companyId,
            vehicleId: vehicleId,
            fromDate: fromDate,
            toDate: toDate,
            offset: offset,
            limit: limit,
            reportName: reportName,
            interval: 0,
            page: pageNo
        };

        var response = await postApi.getClient("report").post("/tracking_report/travel_report", postData);

        this.total = parseInt(response?.data?.data?.TotalCount);
        this.keyNotTagged = response?.data?.data?.startStopData
        this.pageSize = this.keyNotTagged?.length
        this.loading = false;
    }

    async exportExcel(getData) {
        try {
            await postApi.getClient("report").post("/tracking_report/travel_report/download/excel", getData, {
                responseType: "blob",
            });
            this.pythonReportMessage = true;
        } catch (error) {
            this.pythonReportErrorMessage = true;
        }
    }

    async exportpdf(getData) {
        try {
            await postApi.getClient("report").post("/tracking_report/travel_report/download/pdf", getData, {
                responseType: "blob",
            });
            this.pythonReportMessage = true;
        } catch (error) {
            this.pythonReportErrorMessage = true;
        }
    }
}

export default KeynottagRepStore;
